export const categories = [
  { slug: 'baicai-jia', name: '白菜价商品', icon: 'ri-price-tag-3-line', description: '超低价商品，性价比爆棚' },
  { slug: 'lingshou-gou', name: '0元购活动', icon: 'ri-gift-line', description: '免费领取，不花一分钱' },
  { slug: 'mianfei-lingqu', name: '限时免费领取', icon: 'ri-timer-flash-line', description: '限时福利，先到先得' },
  { slug: 'haowu-tuijian', name: '白菜好物推荐', icon: 'ri-thumb-up-line', description: '精选好物，品质有保障' },
  { slug: 'youhuiquan', name: '优惠券合集', icon: 'ri-coupon-line', description: '大额优惠券，省钱利器' },
  { slug: 'pinpai-huodong', name: '品牌活动', icon: 'ri-store-line', description: '大牌促销，折扣不断' },
  { slug: 'xinshou-zhuanqu', name: '新手专区', icon: 'ri-user-star-line', description: '新人专享，福利多多' },
  { slug: 'shenghuo-baikuang', name: '生活百货', icon: 'ri-shopping-bag-line', description: '日用百货，白菜价囤货' },
];

export const categoryArticlesMap: Record<string, string[]> = {
  'baicai-jia': ['article-1', 'article-2', 'article-7', 'article-10', 'article-13', 'article-15'],
  'lingshou-gou': ['article-3', 'article-8', 'article-11', 'article-14'],
  'mianfei-lingqu': ['article-4', 'article-9', 'article-12', 'article-16'],
  'haowu-tuijian': ['article-5', 'article-1', 'article-8', 'article-13'],
  'youhuiquan': ['article-6', 'article-2', 'article-10', 'article-15'],
  'pinpai-huodong': ['article-7', 'article-3', 'article-11'],
  'xinshou-zhuanqu': ['article-14', 'article-16', 'article-4'],
  'shenghuo-baikuang': ['article-5', 'article-9', 'article-12', 'article-6'],
};